export const SURVEY_LAYOUT_TRANSLATE = {
  SCREEN_TITLE: "会員のアンケート",
  PREV_STEP: "戻る",
  NEXT_STEP: "次へ",
  SUBMIT: "送信",
  SUBMIT_SINGLE_MODE: "保存",
  MESSAGE_QUESTION_REQUIRED: "回答を選択してください。",
};
